export default __webpack_public_path__ + "static/media/early-development-preamble.7a7b444c.md";